import React from 'react';
import Button from '../../components/button';
import useGym from 'helpers/use_gym';
import api from 'helpers/api';
import notification from 'helpers/notification';
import { useAngularService } from 'helpers/get_angular_service';

type VerifyEmailModalProps = {
  modalInstance: any;
};

const VerifyEmailModal = (props: VerifyEmailModalProps) => {
  const { modalInstance } = props;

  const gym = useGym();

  const loadingAnimation = useAngularService('loadingAnimation');

  const currentUserEmail = window.currentUser.email;

  const cancel = () => {
    modalInstance.dismiss('cancel');
  };

  const resendVerificationEmail = (params) => {
    const url = `/gyms/${gym.id}/resend_account_owner_verification_email`;
    loadingAnimation.show();
    api.post(url, { review: params }).then(
      () => {
        loadingAnimation.hide();
        cancel();
        notification.success(`Verification email sent to ${currentUserEmail}.`);
      },
      () => {
        loadingAnimation.hide();
        cancel();
        notification.error('Request could not be completed. Please try again');
      },
    );
  };

  return (
    <div>
      <div className="modal-header">
        <a aria-hidden="true" className="close-modal" onClick={cancel} title="Close">
          <i className="icon-cross"></i>
        </a>
        <h4 className="modal-title">Verify your user email address</h4>
      </div>
      <div className="modal-body modal-body-visible">
        <div className="margin-bottom-16">
          <p>
            To ensure we can reach you with important messages about your Clubworx account, we
            need to ensure that your email address ({currentUserEmail}) is valid.
          </p>
        </div>
        <div>
          <p>
            To verify your address, click the button below. You'll receive an email containing a
            link, click on that and you're all set!
          </p>
        </div>
        <div className="margin-bottom-16">
          <strong> Why does this matter?</strong>
        </div>
        <div>
          Since you're the account owner, we'll use this email address to send any important news or
          updates regarding your account. If you have any questions, or difficulty verifying your
          email address, contact our support team today.
        </div>
      </div>

      <div className="modal-footer">
        <Button onClick={cancel}>Cancel</Button>
        <Button variant="success" onClick={resendVerificationEmail}>
          Send Verification Email
        </Button>
      </div>
    </div>
  );
};

angular.module('shared').value('VerifyEmailModal', VerifyEmailModal);
